var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.name},[_c('user-icon'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('module_audience_estimate_target_expansion_hint')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }